import './styles/themes.css';
import './styles/main.css';
import { AtelierSketch } from './art/sketch.js';
import { CanvasRecorder } from './utils/recorder.js';
import { SONG_METADATA, shareToX } from './utils/share.js';

document.addEventListener('DOMContentLoaded', () => {
  const canvasHolder = document.getElementById('canvas-holder');
  const songCards = document.querySelectorAll('.song-card');
  const costumeBtns = document.querySelectorAll('.costume-btn');
  
  // スライダー
  const motionSlider = document.getElementById('slider-motion');
  const densitySlider = document.getElementById('slider-density');
  const glowSlider = document.getElementById('slider-glow');
  const valMotion = document.getElementById('val-motion');
  const valDensity = document.getElementById('val-density');
  const valGlow = document.getElementById('val-glow');

  // アクションボタン
  const btnReroll = document.getElementById('btn-reroll');
  const btnSaveImg = document.getElementById('btn-save-img');
  const btnRecord = document.getElementById('btn-record');
  const btnShare = document.getElementById('btn-share');
  const recordingBadge = document.getElementById('recording-badge');

  // 銘板 & MVカード
  const plateSongTitle = document.getElementById('plate-song-title');
  const mvTitle = document.getElementById('mv-title');
  const mvDesc = document.getElementById('mv-desc');
  const mvLink = document.getElementById('mv-link');

  let currentSong = 'sirius';
  let currentCostume = 'アネモネ I (赤×黒)';

  // レコーダー
  let recorder = null;

  // p5スケッチの初期化
  const sketch = new AtelierSketch(canvasHolder, (canvas) => {
    recorder = new CanvasRecorder(
      canvas,
      (isRecording) => {
        recordingBadge.style.display = isRecording ? 'flex' : 'none';
        btnRecord.disabled = isRecording;
        btnRecord.textContent = isRecording ? '記録中 (5s)...' : '🎥 記憶の記録 (動画)';
      },
      () => {
        recordingBadge.style.display = 'none';
        btnRecord.disabled = false;
        btnRecord.textContent = '🎥 記憶の記録 (動画)';
      }
    );
  });

  // UI情報の更新
  function updateSongInfo(songId) {
    const meta = SONG_METADATA[songId];
    if (!meta) return;

    currentSong = songId;
    plateSongTitle.textContent = `${meta.title} (${meta.engTitle})`;
    mvTitle.textContent = `${meta.no} ${meta.title}`;
    mvDesc.textContent = meta.desc;
    mvLink.href = meta.youtubeUrl;

    songCards.forEach((card) => {
      card.classList.toggle('active', card.dataset.song === songId);
    });

    sketch.setSong(songId);
  }

  // 楽曲カードクリック
  songCards.forEach((card) => {
    card.addEventListener('click', () => {
      const songId = card.dataset.song;
      updateSongInfo(songId);
    });
  });

  // 衣装テーマ切り替え
  costumeBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      costumeBtns.forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');
      const theme = btn.dataset.theme;
      document.body.setAttribute('data-theme', theme);
      currentCostume = btn.textContent.trim();
    });
  });

  // スライダーリスナー
  motionSlider.addEventListener('input', (e) => {
    const v = parseFloat(e.target.value);
    valMotion.textContent = `${Math.round(v * 100)}%`;
    sketch.setParam('motion', v);
  });

  densitySlider.addEventListener('input', (e) => {
    const v = parseFloat(e.target.value);
    valDensity.textContent = `${Math.round(v * 100)}%`;
    sketch.setParam('density', v);
  });

  glowSlider.addEventListener('input', (e) => {
    const v = parseFloat(e.target.value);
    valGlow.textContent = `${Math.round(v * 100)}%`;
    sketch.setParam('glow', v);
  });

  // 🎲 転生（ランダム再生成）
  btnReroll.addEventListener('click', () => {
    const newParams = sketch.randomizeParams();
    motionSlider.value = newParams.motion;
    valMotion.textContent = `${Math.round(newParams.motion * 100)}%`;

    densitySlider.value = newParams.density;
    valDensity.textContent = `${Math.round(newParams.density * 100)}%`;

    glowSlider.value = newParams.glow;
    valGlow.textContent = `${Math.round(newParams.glow * 100)}%`;
  });

  // 📷 画像保存
  btnSaveImg.addEventListener('click', () => {
    sketch.saveImage(`isekai-joucho-${currentSong}-${Date.now()}.png`);
  });

  // 🎥 動画録画
  btnRecord.addEventListener('click', () => {
    if (recorder) {
      recorder.startRecord(5000);
    }
  });

  // 🕊️ Xシェア
  btnShare.addEventListener('click', () => {
    shareToX(currentSong, currentCostume);
  });

  // ⏸ 再生 / 一時停止
  const btnPlay = document.getElementById('btn-play');
  const btnPlayText = document.getElementById('btn-play-text');
  if (btnPlay) {
    btnPlay.addEventListener('click', () => {
      const isPlaying = sketch.togglePlay();
      const icon = btnPlay.querySelector('.icon');
      if (isPlaying) {
        if (icon) icon.textContent = '⏸';
        if (btnPlayText) btnPlayText.textContent = '一時停止';
        btnPlay.classList.remove('paused');
      } else {
        if (icon) icon.textContent = '▶';
        if (btnPlayText) btnPlayText.textContent = '再生';
        btnPlay.classList.add('paused');
      }
    });
  }

  // ⛶ 全画面鑑賞モード
  const btnFullscreen = document.getElementById('btn-fullscreen');
  function setFullscreenMode(active) {
    const isFullscreen = typeof active === 'boolean'
      ? (active ? document.body.classList.add('fullscreen-active') || true : (document.body.classList.remove('fullscreen-active'), false))
      : document.body.classList.toggle('fullscreen-active');

    if (btnFullscreen) {
      btnFullscreen.innerHTML = isFullscreen
        ? '<span class="icon">✖</span> 閉じる'
        : '<span class="icon">⛶</span> 全画面';
    }
    // リサイズ発火
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
  }

  if (btnFullscreen) {
    btnFullscreen.addEventListener('click', () => setFullscreenMode());
  }

  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && document.body.classList.contains('fullscreen-active')) {
      setFullscreenMode(false);
    }
  });

  // 🎛 タブ切り替え（1. 楽曲の選定 / 2. 情緒の調律）
  const tabBtns = document.querySelectorAll('.panel-tab-btn');
  const tabContents = {
    songs: document.getElementById('tab-content-songs'),
    params: document.getElementById('tab-content-params')
  };

  tabBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const targetTab = btn.dataset.tab;
      tabBtns.forEach((b) => {
        const isActive = b === btn;
        b.classList.toggle('active', isActive);
        b.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      Object.entries(tabContents).forEach(([key, contentEl]) => {
        if (contentEl) {
          contentEl.classList.toggle('active', key === targetTab);
        }
      });
    });
  });

  // 初期曲の設定
  updateSongInfo('sirius');
});
